<template>
  <div>
    <h4 class="test">HEY</h4>
  </div>
</template>

<script>

  export default {
      name: 'sidebar-gallery',
      data() {
          return {   
          }
      },
  }
</script>

<style scoped>
  .test {
    color: green;
  }
</style>
